import type { HttpMiddleware, RequestObj } from '../models';

export class WAFChallengeError extends Error {
    constructor() {
        super( 'AWS WAF challenge response received' );
        this.name = 'WAFChallengeResponse';
    }
}

export default function( next: HttpMiddleware ) {
    return async function( url: string, request: RequestObj ): Promise<Response> {
        const response: Response = await next( url, request );

        if ( response.status === 202 && response.headers.get( 'x-amzn-waf-action' ) === 'challenge' ) {
            throw new WAFChallengeError();
        }

        return response;
    };
}
